/** Loading state shown while a lazily-loaded route chunk is fetched. */
export default function PageLoader() {
  return (
    <div
      className="grid min-h-[60vh] place-items-center"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-4">
        <span
          className="h-9 w-9 animate-spin rounded-full border-2 border-line-strong border-t-brand"
          aria-hidden="true"
        />
        <span className="text-sm text-content-muted">Chargement…</span>
      </div>
    </div>
  );
}
